import React from 'react';
import './FormField.css';

const FormField = ({ 
  label, 
  required = false, 
  error, 
  help, 
  children, 
  className = '' 
}) => {
  return (
    <div className={`form-field ${className} ${error ? 'has-error' : ''}`}>
      {label && (
        <label className={`form-label ${required ? 'required' : ''}`}>
          {label}
        </label>
      )}
      
      <div className="form-field-content">
        {children}
      </div>
      
      {error && (
        <div className="form-error">
          {error}
        </div>
      )}
      
      {help && !error && (
        <div className="form-help">
          {help}
        </div>
      )}
    </div>
  );
};

export default FormField;
